import type { Analytics, AnalyticsBrowser } from '@segment/analytics-next'
import {
  createContext,
  type FunctionComponent,
  type PropsWithChildren,
  useEffect,
  useState,
} from 'react'
import config from '@/config'

export const SegmentContext = createContext<Analytics | undefined>(undefined)

const SegmentProvider: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const [analytics, setAnalytics] = useState<Analytics | undefined>(undefined)

  useEffect(() => {
    if (!config.prod) return

    // AnalyticsBrowser.load() returns a BUFFERED instance: track/page calls
    // made before the SDK finishes loading are queued and flushed once it is
    // ready. Set it into context immediately (do NOT await the load promise)
    // so early events — e.g. the What's New page_viewed that fires on mount —
    // are never silently dropped.
    try {
      const response = AnalyticsBrowser.load({
        writeKey: 'u2GHkUwvxg0vUTLMWiwxzPafW29rGs5P',
      })
      setAnalytics(response as unknown as Analytics)
    } catch (e) {
      console.error(e)
    }
  }, [])

  return (
    <SegmentContext.Provider value={analytics}>
      {children}
    </SegmentContext.Provider>
  )
}

export default SegmentProvider
